/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { themeGet } from 'styled-system';
import { Button, Text, Flex } from 'roo-ui/components';
import { useDialog } from 'components/Dialog';
import { BOOKING_CONFIRMATION_NPS_SURVEY_URL } from 'config';
import { useDataLayer } from 'hooks/useDataLayer';
import { getBooking } from 'store/booking/bookingSelectors';

const CloseDialogBtn = styled(Button)`
  background: transparent;
  color: ${themeGet('colors.brand.primary')};

  &:hover {
    background: transparent;
    color: ${themeGet('colors.ui.linkHover')};
  }
`;

const OneLineContent = () => (
  <Text fontSize={['sm', 'base']} mt={4} display={['none', 'block']}>
    To help us improve, we&apos;d like to ask you a few questions about your booking experience with us. Our short survey will take about
    1-2 minutes.
  </Text>
);

const TwoLinesContent = () => (
  <Flex flexDirection="column" display={['block', 'none']}>
    <Text fontSize={['sm', 'base']} mt={4}>
      To help us improve, we&apos;d like to ask you a few questions about your booking experience with us.
    </Text>
    <Text fontSize={['sm', 'base']} mt={4}>
      Our short survey will take about 1-2 minutes.
    </Text>
  </Flex>
);

const NpsSurveyDialog = () => {
  const { emitInteractionEvent } = useDataLayer();
  const { Dialog, closeDialog, openDialog } = useDialog();
  const booking = useSelector(getBooking);
  const showNpsSurveyDialog = get(booking, 'showNpsSurveyAfterBooking');
  const reference = get(booking, 'reference');
  const surveyUrlParsed = new URL(BOOKING_CONFIRMATION_NPS_SURVEY_URL);

  useEffect(() => {
    if (showNpsSurveyDialog) {
      setTimeout(openDialog, 3000);
    }
  }, [showNpsSurveyDialog, openDialog]);

  const surveyUrlWithUserAgent = () => {
    const urlWithParameters = !!surveyUrlParsed.search;

    if (urlWithParameters) {
      return BOOKING_CONFIRMATION_NPS_SURVEY_URL + '&user_agent=' + window.navigator.userAgent;
    } else {
      return BOOKING_CONFIRMATION_NPS_SURVEY_URL + '?user_agent=' + window.navigator.userAgent;
    }
  };

  const openSurvey = () => {
    window.open(`${surveyUrlWithUserAgent()}&ref=${reference}`);
    closeDialog();
    emitInteractionEvent({ type: 'NPS Survey Pop Up', value: 'Take A Survey Selected' });
  };

  const closeDialogWindow = () => {
    closeDialog();
    emitInteractionEvent({ type: 'NPS Survey Pop Up', value: 'Not Now Selected' });
  };

  return (
    <Dialog>
      <Flex flexDirection="column" data-testid="dialog-survey">
        <Text fontWeight="bold" fontSize="md">
          Thanks for choosing Qantas Hotels!
        </Text>
        <OneLineContent />
        <TwoLinesContent />
      </Flex>
      <Flex mt={6} flexDirection={['column', 'row']}>
        <Button variant="primary" mr={[0, 6]} onClick={openSurvey} data-testid="open-survey" tabIndex="1">
          take a survey
        </Button>
        <CloseDialogBtn mt={[4, 0]} onClick={closeDialogWindow} data-testid="close-dialog" tabIndex="2">
          not now
        </CloseDialogBtn>
      </Flex>
    </Dialog>
  );
};

export default NpsSurveyDialog;
